<app-intro *ngIf="playIntro" (finished)="onIntroFinished($event)"></app-intro>